import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button, Table } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase, momentDate
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import {message, Tooltip, Skeleton, Space, Drawer, Spin} from 'antd';

import PsContext from '../../context/PsContext';

class UpdateCollectionEntry extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
			customers: [],
			dataList: [],
			dataView: [],
			editData: [],
			selectedRows: [],
			showSubMenu: false,
			tableView: true,
		}
	
		this.handleSubMenuClose = this.handleSubMenuClose.bind(this);
		this.handleSubMenuOpen = this.handleSubMenuOpen.bind(this);
		this.handleDeleteClick = this.handleDeleteClick.bind(this);
		this.confirmDelete = this.confirmDelete.bind(this);
		this.handleSearchclick = this.handleSearchclick.bind(this);
		this.handleSearchOnChange = this.handleSearchOnChange.bind(this);
		this.handleAllSelect = this.handleAllSelect.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Update Collection Entry',
			back: true,
			to: '/app',
		});
		//this.loadData();
		this.loadCustomerData();
	}
		
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}

	loadCustomerData(){
		try{
			this.setState({
				showLoader: true,
				dataList: [],
				dataView: [],
			});
			axios.get(Api.Url+'v1/customers?api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						customers: res['data'].data,						
					});
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	loadData(){
		try{
			this.setState({
				dataView: [],
				dataList: [],
				showLoader: true,
			});
			axios.get(Api.Url+'v1/collection/bydate?api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						dataList: res['data'].data,
						dataView: res['data'].data,						
					});
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	handleSubMenuOpen(record){
		this.setState({
			editData: record,
			showSubMenu: true,
		});
	}
	
	handleSubMenuClose(){
		this.setState({
			editData: [],
			showSubMenu: false,
		});
	}
	
	getUserInfo(field){
		try{
			var d = this.state.editData;
			return d[field];
		}
		catch(er){ }
	}
	
	handleDeleteClick(){
		var $this = this;
		$.confirm({
			title: 'Confirm',
			content: 'Do you want to delete?',
			buttons: {
				Yes:  function(){
					$this.confirmDelete();
				},
				No: function(){ }
			}
		});
	}
	
	confirmDelete(){
		try{
			this.setState({showLoader: true});
			var form = new FormData();
			var uId = this.getUserInfo('id');
			form.append('api', this.context.state.api);
			form.append('i__id', uId);
			axios.post(Api.Url+'v1/collection/remove', form).then(res=>{
				if(res['data'].status=='1'){
					message.success(res['data'].message || 'Success');
					var d = this.state.dataList;
					var index = d.findIndex(function(obj){
						return(obj.id==uId);
					});
					if(index>=-1)
						d.splice(index,1);
					console.log(d);
					this.setState({
						dataList: d,
						dataView: d,
						showLoader: false,
						editData: [],
						showSubMenu: false,
					});
				}
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false});
				}
			});
		}
		catch(error){
			console.log(error);
			this.setState({showLoader: false});
		}
	}
	
	handleSearchclick(){
		try{
			var d = document.getElementById("i__fromDate").value;
			if( !d && d.length<5){
				message.error('Select from date');
				return;
			}
			
			var t = document.getElementById("i__toDate").value;
			if( !t && t.length<5){
				message.error('Select to date');
				return;
			}

			var s = document.getElementById("i__shift").value;
			
			this.setState({
				dataView: [],
				dataList: [],
				showLoader: true,
			});
			axios.get(Api.Url+'v1/collection/bydate_temp?i__shift='+s+'&i__fromDate='+d+'&i__toDate='+t+'&api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						dataList: res['data'].data,
						dataView: res['data'].data,						
					});
				}
				else{
					message.error(res['data'].message || 'Error');
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	handleSearchOnChange(e){
		try{
			var v = upperCase(e.target.value);
			var d = this.state.dataList.filter(function(obj){
				return( (upperCase(obj.customer_name).indexOf(v)>-1) || 
				(upperCase(obj.customer_mobile).indexOf(v)>-1));
			});
			console.log(d);
			this.setState({dataView: d});
		}
		catch(error){ }
	}
	
	calculateTotal(fieldName){
		try{
			var d = this.state.dataView;
			var total = 0;
			d.map((item,i)=>{
				total = parseFloat(total) + parseFloat(item[fieldName]);
			});
			return parseFloat(total).toFixed(2);
		}
		catch(er){
			
		}
	}
	
	getAvg(field){
		try{
			var total = this.calculateTotal(field);
			var size = Object.keys(this.state.dataView).length;
			
			var avg = parseFloat(total) / parseFloat(size);
			
			return parseFloat(avg).toFixed(2);
		}
		catch(error){ }
	}
	
	handleRowSelect(record){
		try{
			var d = this.state.selectedRows;
			var index = d.findIndex(function(obj){
				return(obj.id==record.id);
			});
			
			if(index>-1)
				d.splice(index,1);
			else
				d.push(record);
			
			this.setState({selectedRows: d});
		}
		catch(error){ }
	}
	
	checkRowSelected(record){
		try{
			var d = this.state.selectedRows;
			var index = d.findIndex(function(obj){
				return(obj.id==record.id);
			});
			
			return (index>-1);
		}
		catch(error){ }
	}
	
	handleAllSelect(){
		try{
			if(Object.keys(this.state.dataView).length == Object.keys(this.state.selectedRows).length)
				this.setState({selectedRows: []});
			else
				this.setState({selectedRows: this.state.dataView});
		}
		catch(error){ }
	}
	
	handleDelete(){
		try{
			
			if(!window.confirm('Do you want to delete the selected records?'))
				return;
			
			this.setState({showLoader: true});
			var s = [];
			this.state.selectedRows.map((item,i)=>{
				s.push(item.id);
			});
			var form = new FormData();
			form.append('api', this.context.state.api);
			form.append('i__data', JSON.stringify(s));
			axios.post(Api.Url+'v1/collection/bulk_remove',form).then(res=>{
				if(res['data'].status=='1'){
					message.success(res['data'].message || 'Success');
					this.setState({
						dataList: [],
						dataView: [],
						selectedRows: [],
						showLoader: false
					});
				}
				else{
					message.error(res['data'].message || 'Error');
					this.setState({
						showLoader: false
					});
				}
			});
		}
		catch(error){ 
			this.setState({showLoader: false});
		}
	}

	handleCodeChange(item, e){
		
		let dv = this.state.dataView;
		let index = dv.findIndex(obj => obj.id==item.id);
		
		if(index>-1){

			let cus = this.state.customers.find(obj => obj.customer_code==e.target.value);
			dv[index]['customer_name'] = (cus && cus.customer_name) ? cus.customer_name : 0;
			dv[index]['customer_id'] = (cus && cus.id) ? cus.id : 0;
			dv[index]['customer_code'] = e.target.value;
			this.setState({dataView: dv});
		}
	}

	handleWeightChange(item, e){
		
		let dv = this.state.dataView;
		let index = dv.findIndex(obj => obj.id==item.id);
		
		if(index>-1){

			
			var weight = e.target.value;
			var lit = (parseFloat(weight)/ 1.03).toFixed(1);
			var fat = item.fat;
			
			var snf = ( (parseFloat(item.clr)/4) + (0.20 * parseFloat(fat)) + 0.36).toFixed(2);
			var ts = item.ts_value; //this.context.state.company.ts_value;
			var rate = ( (parseFloat(fat) + parseFloat(snf)) * parseFloat(ts)).toFixed(2);
			rate = (parseFloat(rate)/100).toFixed(2);
			var total = (parseFloat(rate) * parseFloat(lit)).toFixed(2);

			dv[index]['weight'] = weight;
			dv[index]['litters'] = lit;
			dv[index]['fat'] = fat;
			dv[index]['amount'] = rate;	
			dv[index]['total'] = total;	

			this.setState({dataView: dv});
		}
	}
	
	handleUpdateFormSubmit(e){
		e.preventDefault();
		if(!window.confirm('Do you want to update?')){
			return;
		}

		this.setState({showLoader: true});
		//
		//
		this.setState({showLoader: true});
		axios.post(Api.Url+'v1/collection/update_temp', $("#frmUpdate_col").serialize()).then(res=>{
			if(res['data'].status=='1'){
				
				message.success(res['data'].message || 'Success');
				this.setState({showLoader: false});
				
			}	
			else{
				message.error(res['data'].message || 'Error');
				this.setState({showLoader: false});
			}
		});
		
	}

	handleRowDelete(item){
		if(!window.confirm('Do you want to delete?')){
			return;
		}
		console.log(item);
		this.setState({showLoader: true});
		const form = new FormData();
		form.append('api', this.context.state.api);
		form.append('id', item.id);
		axios.post(Api.Url+'v1/collection/remove_temp', form).then(res=>{
			if(res['data'].status=='1'){
				let s = this.state.dataView;

				let index = s.findIndex(obj => obj.id==item.id);
				if(index>-1){
					s.splice(index,1);
				}
				//let m = s.filter(obj !== item);
				this.setState({dataView: s});
			}
			else{
				alert(res['data'].message || 'Error');
			}
			this.setState({showLoader: false});
		});
		
	}
	
	render(){

		const skelton = <Space className="mb-20" >			
			  <Skeleton.Input style={{ width: 'calc(100vw)' }} active={true} size={"small"} />
		</Space>;
		return(
		<div className="container" >
			<div data-aos="fade" >
				
				<Spin spinning={this.state.showLoader} >
				
				<Row className="mb-15" >
					<Col md={3} >
						<Form.Control
							as="select"
							id="i__shift"
						>
							<option value="Morning">Morning</option>
							<option value="Evening">Evening</option>
						</Form.Control>
					</Col>
					<Col md={3} >
						<Form.Control
							type="date"
							size="xs"
							id="i__fromDate"
							max={momentDate((new Date()),'YYYY-MM-DD')}
							defaultValue={momentDate((new Date()),'YYYY-MM-DD')}
						/>
					</Col>
					<Col md={3} >
						<Form.Control
							type="date"
							size="xs"
							id="i__toDate"
							max={momentDate((new Date()),'YYYY-MM-DD')}
							defaultValue={momentDate((new Date()),'YYYY-MM-DD')}
						/>
					</Col>
					<Col md={2} >
						<Button
							type="button"
							size="lg"
							variant="primary"
							block
							onClick={this.handleSearchclick} 
						>
							VIEW
						</Button>
					</Col>
				</Row>
				
			
			{!this.state.tableView ? <>
				{this.state.dataView.map((item,i)=>{
					return <div className="card settings-card">
						<div className="card-body">
						  <div className="single-settings d-flex align-items-center justify-content-between">
							<div className="title">
								<div className="font-weight-600" >{item.customer_name}</div>
								<span>{item.customer_address}</span> <br />
								<div>Litters : {item.litters}, <span className="icofont-rupee"></span> {item.total}</div>
							</div>
							<div className="data-content">
							  <div className="font-20" onClick={this.handleSubMenuOpen.bind(this, item)} >
								<i className="icofont-arrow-right"></i>
							  </div>
							</div>
						  </div>
						</div>
					  </div>;
				})
				}
				</> : <>
					<Card>
					<Card.Body>
					{Object.keys(this.state.selectedRows).length>0 ? <div className="mb-15 text-center" >
						<Button
							type="button"
							variant="danger"
							size="sm"
							onClick={this.handleDelete} 
						>
						DELETE SELECTED RECORDS
						</Button>
					</div> : null}
					<Table size="sm" className="table table-sm table-bordered font-14" >
						<thead>
							<tr>
								<th width="50" >S.No</th>
								<th width="50" >Date</th>
								<th>Customer</th>
								<th width="90"  >Shift</th>
								<th width="110"  >Code</th>
								<th width="110"  >Weight</th>
								<th width="80"  >Litters</th>
								<th width="80"  >Fat</th>
								<th width="80" >CLR</th>
								<th width="80"  >SNF</th>
								<th>Rate</th>
								<th>Total</th>
								<th>#</th>
							</tr>
						</thead>
						<tbody>
						{this.state.dataView.map((item,i)=>{
							return <tr key={i }>
								<td>{i+1}</td>
								<td  align="" >{momentDate(item.entry_on)}</td>
								<td>{item.customer_name}</td>
								<td  align="right" >{item.shift}</td>
								<td  align="right" >
									<Form.Control
										type="number"
										size="sm"
										value={item.customer_code}
										onChange={this.handleCodeChange.bind(this, item)}
									/>	
								</td>
								<td  align="right" >
									<Form.Control
										type="number"
										size="sm"
										value={item.weight}
										onChange={this.handleWeightChange.bind(this, item)}
									/>	
								</td>
								<td  align="right" >{item.litters}</td>
								<td  align="right" >{item.fat}</td>
								<td  align="right" >{item.clr}</td>
								<td  align="right" >{item.snf}</td>
								<td align="right"  >{item.amount}</td>
								<td align="right" >{item.total}</td>
								<td align="center">
								<Button type="button" size="sm" variant="danger" onClick={this.handleRowDelete.bind(this, item)}>
									<i className="icofont-trash" ></i>
								</Button>
							</td>
							</tr>
						})
						}
						<tr className="font-weight-600" >
							<td colSpan="5" align="right" >Total : </td>
							<td  align="right" >{this.calculateTotal('weight')}</td>
							<td  align="right" >{this.calculateTotal('litters')}</td>
							<td  align="right" >Avg: &nbsp; {this.getAvg('fat')}</td>
							<td></td>
							<td  align="right" >Avg :&nbsp; {this.getAvg('snf')}</td>
							<td align="right"  >{this.getAvg('amount')}</td>
							<td align="right" >{this.calculateTotal('total')}</td>
							<td></td>
						</tr>
						</tbody>
					</Table>
						
						{this.state.dataView.length>0 && (<form action="" method="post" id="frmUpdate_col" onSubmit={this.handleUpdateFormSubmit.bind(this)}>
						<input type="hidden" name="api" value={this.context.state.api} />
						<input type="hidden" name="data" value={JSON.stringify(this.state.dataView)} />
								<Row>
									<Col md={12}>
										<div className='text-right'>
											<Button
												type="submit"	
												variant="success"											
											>
												UPDATE
											</Button>
										</div>
									</Col>
								</Row>
						</form>)}
					</Card.Body>
				</Card>
			</>}
				 
			</Spin>
			</div>
			
				<div className="btn-fab-btm-right" >
					<Tooltip title="Collection Entry" >
						<Link to="/app/collection/new" className="ant-btn ant-btn-primary ant-btn-circle ant-btn-lg ant-btn-icon-only" >
							<i className="icofont-plus"></i>
						</Link>
					</Tooltip>
				 </div>
				 
				  <Drawer
					  placement={"bottom"}
					  closable={true}
					  onClose={this.handleSubMenuClose} 
					  visible={this.state.showSubMenu}
					  height={'350px'}
					  title={this.getUserInfo('customer_name')}
					>
					
					 <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="lni lni-empty-file"></i><span>Code</span></div>
						<div className="data-content">{this.getUserInfo('customer_code')}</div>
					  </div>
					  <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="lni lni-phone"></i><span>Phone</span></div>
						<div className="data-content">{this.getUserInfo('customer_mobile')}</div>
					  </div>
					  <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="lni lni-map-marker"></i><span>Address</span></div>
						<div className="data-content">{this.getUserInfo('customer_address')}</div>
					  </div>
					 <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="lni lni-funnel"></i><span>Litters</span></div>
						<div className="data-content">{this.getUserInfo('litters')}</div>
					  </div>
					   <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="lni lni-rupee"></i><span>Total</span></div>
						<div className="data-content">{this.getUserInfo('total')}</div>
					  </div>
					  
					  <Row>
					  {/*<Col xs={6} >
						  <div className="push-right" style={{float: 'right'}} >
							<Link 
								className="btn btn-warning btn-md"
								style={{width: '150px'}}
								to={"/app/collection/edit/"+this.getUserInfo('id')} 
							>
								<i className="lni lni-pencil-alt"></i> EDIT
							</Link>
						  </div>
					  </Col>*/}
					  <Col xs={12} >
						   <div className="push-right" style={{float: 'right'}}  >
							<Button
								type="button"
								size="md"
								variant="danger"
								style={{width: '150px'}}
								onClick={this.handleDeleteClick}
							>
								<i className="lni lni-cross-circle"></i> DELETE
							</Button>
						  </div>
					  </Col>
					 </Row>
					
					</Drawer>
			</div>
		);
	}
	
}
export default UpdateCollectionEntry;
